// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tag[data-v-4b1c9185] {\n  margin: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
